import { axiosUser } from '@axios/axiosInstances';
import dayjs from 'dayjs';
export const BOOKING_URL = `/booking2`;
export const BOOKING_ADMIN_URL = `/booking2/admin`;
export const BOOKING_BRANCH_URL = `/booking2/branch`;
export const BOOKING_SETTING_URL = `/booking2/setting`;
export const PACKAGE_URL = `/package/packages`;

export const createBookingBranch = body => axiosUser.post(`${BOOKING_BRANCH_URL}/create`, body);

export const updateShopSettingBooking = (shopId, shopBookingSetting) =>
  axiosUser.patch(`${BOOKING_SETTING_URL}/shopsetting/toggleShopSettingBooking/${shopId}`, shopBookingSetting);

export const fetchBookingShopSetting = shopId => axiosUser.get(`${BOOKING_SETTING_URL}/shopsetting/${shopId}`);

export const toggleActiveBookingBranch = branchId =>
  axiosUser.patch(`${BOOKING_SETTING_URL}/${branchId}/toggleActiveBranch`);

export const editBookingBranch = (branchId, branchForm) =>
  axiosUser.post(`${BOOKING_BRANCH_URL}/edit/${branchId}`, branchForm);

export const duplicateBranch = branchId => axiosUser.post(`${BOOKING_BRANCH_URL}/duplicate/${branchId}`);

export const getBookingBranchList = () => axiosUser.get(`${BOOKING_BRANCH_URL}`);

export const getBranchsList = shopId => axiosUser.get(`${BOOKING_BRANCH_URL}/branch/${shopId}`);

export const getBookingBranch = branchId => axiosUser.get(`${BOOKING_BRANCH_URL}/${branchId}`);

export const saveBookingServiceSetting = (branchId, body) =>
  axiosUser.post(`${BOOKING_SETTING_URL}/${branchId}/create`, body);

export const getBookingServicesList = branchId => axiosUser.get(`${BOOKING_SETTING_URL}/${branchId}/service`);

export const submitBookingServiceName = (branchId, serviceForm) =>
  axiosUser.post(`${BOOKING_SETTING_URL}/${branchId}/addService`, serviceForm);

export const deleteBookingService = (branchId, serviceId) =>
  axiosUser.delete(`${BOOKING_SETTING_URL}/${branchId}/deleteService/${serviceId}`);

export const getServiceById = (branchId, serviceId, shopId) =>
  axiosUser.get(`${BOOKING_SETTING_URL}/${branchId}/service/${serviceId}`, {
    params: {
      shopId
    }
  });

export const saveEditService = (branchId, serviceId, serviceForm) =>
  axiosUser.patch(`${BOOKING_SETTING_URL}/${branchId}/editService/${serviceId}`, serviceForm);

export const duplicateService = (branchId, serviceId) =>
  axiosUser.post(`${BOOKING_SETTING_URL}/${branchId}/duplicateService/${serviceId}`);

export const createHoliday = (branchId, holidayForm) =>
  axiosUser.post(`${BOOKING_SETTING_URL}/${branchId}/holidays/createHoliday`, holidayForm);

export const getHolidaysList = branchId => axiosUser.get(`${BOOKING_SETTING_URL}/${branchId}/holidays`);

export const deleteHolidayById = (branchId, holidayId) =>
  axiosUser.delete(`${BOOKING_SETTING_URL}/${branchId}/holidays/deleteHoliday/${holidayId}`);

export const deleteManyHolidays = (branchId, input) =>
  axiosUser.patch(`${BOOKING_SETTING_URL}/${branchId}/holidays/deleteManyHolidays`, input);

export const getHolidayById = (branchId, holidayId) =>
  axiosUser.get(`${BOOKING_SETTING_URL}/${branchId}/holidays/${holidayId}`);

export const editHoliday = (branchId, holidayForm) =>
  axiosUser.patch(`${BOOKING_SETTING_URL}/${branchId}/holidays/editHoliday`, holidayForm);

export const getBookingSetting = branchId => axiosUser.get(`${BOOKING_SETTING_URL}/${branchId}/bookingSetting`);

export const getBookingSettingForCreateBooking = branchId =>
  axiosUser.get(`${BOOKING_SETTING_URL}/${branchId}/bookingSettingCreateBooking`);

export const getAvailableTimesListOfBookingService = query =>
  axiosUser.get(`${BOOKING_URL}/availableTimesList?${query}`);

export const getBookingServicesListFirst = (branchId, bookingDate, shopId, bookingId) => {
  if (!bookingDate) {
    return Promise.reject(new Error('bookingDate is required'));
  }

  return axiosUser.get(`${BOOKING_URL}/servicesList/${branchId}/${bookingDate}/${shopId}`, {
    params: { bookingId }
  });
};
export const createBooking = form => axiosUser.post(`${BOOKING_URL}/createBooking`, form);

export const editBooking = form => axiosUser.patch(`${BOOKING_URL}/editBooking`, form);

export const fetchBookingBranchListCreateBookingPage = shopId =>
  axiosUser.get(`${BOOKING_URL}/bookingBranchsList/${shopId}`);

export const getBookingTimesListFirst = (branchId, serviceDate, bookingId) =>
  axiosUser.get(`${BOOKING_URL}/timesList/${branchId}?serviceDate=${serviceDate}`, {
    params: { bookingId }
  });

export const getBookingServicesListSecond = query => axiosUser.get(`${BOOKING_URL}/availableServicesList?${query}`);

export const getBookingServicesListAllBranch = () => axiosUser.get(`${BOOKING_URL}/servicesList`);

export const getBookingsListOfAllBranchsForCalendar = selectedStatus =>
  axiosUser.get(`${BOOKING_URL}/bookingsListCalendar`, { params: { selectedStatus } });

export const getBookingsListOfBranchForCalendar = (branchId, selectedStatus) =>
  axiosUser.get(`${BOOKING_URL}/bookingsListCalendar/${branchId}`, { params: { selectedStatus } });

export const getBookingDetailById = bookingId => axiosUser.get(`${BOOKING_URL}/booking/${bookingId}`);

export const updateConfirmStatusBooking = (bookingId, confirmNote) =>
  axiosUser.patch(`${BOOKING_URL}/booking/${bookingId}/confirmBooking`, { confirmNote });

export const updateCancelStatusBookingForMember = (bookingId, cancelNote) =>
  axiosUser.patch(`${BOOKING_URL}/booking/${bookingId}/cancelBookingMember`, { cancelNote });

export const updateCancelStatusBookingForAdmin = (bookingId, cancelNote) =>
  axiosUser.patch(`${BOOKING_URL}/booking/${bookingId}/cancelBookingAdmin`, { cancelNote });

export const updateBookingCondition = (branchId, formData) =>
  axiosUser.patch(`${BOOKING_SETTING_URL}/${branchId}/setBookingCondition`, formData);

export const updateWorkingDays = (branchId, values) =>
  axiosUser.patch(`${BOOKING_SETTING_URL}/${branchId}/updateWorkingDays`, values);

export const fetchBookingSettingListWithBranch = shopId =>
  axiosUser.get(`${BOOKING_URL}/bookingSettingAndBranchList/${shopId}`);

export const getBookingsListForAdmin = query => axiosUser.get(`${BOOKING_ADMIN_URL}/bookingsList?${query}`);

export const getBookingsListForCustomer = query => axiosUser.get(`${BOOKING_URL}/customer/bookingsList?${query}`);

export const getBranchClosedDaysIndex = branchId => axiosUser.get(`${BOOKING_URL}/branchcloseddays/${branchId}`);

export const getFullBookingDates = (branchId, selectedMonth, bookingId) => {
  const params = {};
  if (bookingId) params.bookingId = bookingId;
  return axiosUser.get(`${BOOKING_URL}/fullbookingdates/${branchId}/${selectedMonth}`, {
    params
  });
};

export const getCustomDateList = (branchId, serviceId) =>
  axiosUser.get(`${BOOKING_SETTING_URL}/${branchId}/customDate/${serviceId}`);

export const createCustomDate = (branchId, serviceId, customDateForm) =>
  axiosUser.post(`${BOOKING_SETTING_URL}/${branchId}/customDate/${serviceId}`, customDateForm);

export const editCustomDate = (branchId, serviceId, customDateForm) =>
  axiosUser.patch(`${BOOKING_SETTING_URL}/${branchId}/customDate/${serviceId}`, customDateForm);

export const deleteCustomDate = (branchId, serviceId, customId) =>
  axiosUser.delete(`${BOOKING_SETTING_URL}/${branchId}/customDate/${serviceId}/${customId}`);

export const getCustomRegistration = (branchId, shopId) =>
  axiosUser.get(`${BOOKING_SETTING_URL}/${branchId}/customRegistration/${shopId}`);

export const createCustomRegistration = (branchId, customField) =>
  axiosUser.post(`${BOOKING_SETTING_URL}/${branchId}/customRegistration`, { customField });

export const editCustomRegistration = (branchId, customField, customFieldsId) =>
  axiosUser.patch(`${BOOKING_SETTING_URL}/${branchId}/customRegistration/${customFieldsId}`, { customField });

export const getBookingSettingWithShopId = (branchId, shopId) =>
  axiosUser.get(`${BOOKING_SETTING_URL}/${branchId}/bookingSetting/${shopId}`);

export const getPaymentSetting = branchId => axiosUser.get(`${BOOKING_SETTING_URL}/${branchId}/payment`);

export const createPaymentSetting = (branchId, payment) =>
  axiosUser.post(`${BOOKING_SETTING_URL}/${branchId}/payment`, payment);

export const editPaymentSetting = (branchId, payment) =>
  axiosUser.patch(`${BOOKING_SETTING_URL}/${branchId}/payment`, payment);

export const updateApproveStatusBooking = bookingId =>
  axiosUser.patch(`${BOOKING_URL}/booking/${bookingId}/approveBooking`);

export const updateServiceImages = (serviceId, serviceImages) =>
  axiosUser.patch(`${BOOKING_SETTING_URL}/${serviceId}/service/image`, serviceImages);

export const getServiceImages = serviceId => axiosUser.get(`${BOOKING_SETTING_URL}/${serviceId}/image/service/`);

export const updateReviewSetting = (branchId, isReview) =>
  axiosUser.patch(`${BOOKING_SETTING_URL}/${branchId}/review`, { isReview });

export const createReview = reviewData => axiosUser.post(`${BOOKING_URL}/review`, reviewData);

export const updateReview = (reviewId, reviewData) => axiosUser.patch(`${BOOKING_URL}/review/${reviewId}`, reviewData);

export const getReviews = branchId => axiosUser.get(`${BOOKING_URL}/review/${branchId}`);

export const getReviewById = bookingId => axiosUser.get(`${BOOKING_URL}/review/${bookingId}`);

export const getReviewByBranchId = async (branchId, rating, page = 1, limit = 10) => {
  const params = { page, limit };
  if (rating) params.rating = rating;
  const { data } = await axiosUser.get(`${BOOKING_URL}/review/branch/${branchId}`, { params });
  return data;
};

export const getAverageReviews = branchId => axiosUser.get(`${BOOKING_URL}/review/average/${branchId}`);

export const updateReviewStatus = (reviewId, status) =>
  axiosUser.patch(`${BOOKING_URL}/review-status/${reviewId}`, status);

export const getShopPaymentSetting = branchIds =>
  axiosUser.get(`${BOOKING_SETTING_URL}/shop/payment`, { params: { branchIds: branchIds } });

export const getPaymentSettingByBookingId = bookingId =>
  axiosUser.get(`${BOOKING_SETTING_URL}/payment-setting/booking-group-number/${bookingId}`);

export const updateBookingSlip = (bookingId, bookingForm) =>
  axiosUser.patch(`${BOOKING_URL}/upload-slip/${bookingId}`, bookingForm);

export const getHotelService = (branchId, shopId, bookingDate, endBookingDate, isEditMode, bookingId) =>
  axiosUser.get(`${BOOKING_URL}/hotel/service/${branchId}/${shopId}`, {
    params: {
      bookingDate,
      endBookingDate,
      isEditMode,
      bookingId
    }
  });

export const getHotelFullBookingDates = (branchId, selectedMonth, bookingId) => {
  const params = {};
  if (bookingId) params.bookingId = bookingId;
  return axiosUser.get(`${BOOKING_URL}/hotel/fullbookingdates/${branchId}/${selectedMonth}`, {
    params
  });
};

export const createHotelBooking = form => axiosUser.post(`${BOOKING_URL}/hotel/create`, form);

export const editHotelBooking = form => axiosUser.patch(`${BOOKING_URL}/hotel/edit`, form);

export const createBookingNotiSetting = (branchId, settingData) =>
  axiosUser.post(`${BOOKING_SETTING_URL}/${branchId}/noti`, { settingData });

export const updateBookingNotiSetting = (branchId, settingData) =>
  axiosUser.patch(`${BOOKING_SETTING_URL}/${branchId}/noti`, { settingData });

export const getBookingNotiSetting = branchId => axiosUser.get(`${BOOKING_SETTING_URL}/${branchId}/noti`);

export const updateCancelStatusBookingForNonMember = (bookingId, cancelNote, token) =>
  axiosUser.patch(`${BOOKING_URL}/booking/${bookingId}/cancelBookingNonMember`, { cancelNote, token });

export const getPaymentDate = bookingId => axiosUser.get(`${BOOKING_URL}/payment/${bookingId}`);

export function reorderBookingServices(branchId, serviceIds) {
  return axiosUser.patch(`${BOOKING_SETTING_URL}/${branchId}/services/order`, { serviceIds });
}

export const getPackages = () => axiosUser.get(`${PACKAGE_URL}`);

export const getUserPackages = (userId, bookingDate) =>
  axiosUser.get(`${BOOKING_URL}/package`, {
    params: { userId, bookingDate: bookingDate ? dayjs(bookingDate).toISOString() : undefined }
  });
